import { useEffect, useState } from "react";
import { API_URI } from "../axios";

export const useFetchSloganData = () => {
  const [slogan, setSlogan] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSlogan = async () => {
      try {
        const res = await fetch(`${API_URI}/en/api/slogan/`);
        const data = await res.json();
        setSlogan(data);
      } catch (error) {
        console.error("Ошибка загрузки данных:", error);
        setSlogan(null);
      } finally {
        setLoading(false);
      }
    };

    fetchSlogan();
  }, []);

  return { slogan, loading };
};
